Any associated actions that can be performed on the candidate profile.

Only one of each type of action is permitted for the candidate profile.
Currently, only a `ViewProfile` action type is defined to provide a URL to view the candidate's profile.
